import React from "react";
import CourseLandingPage from "../components/CourseLandingPage";
import { BUNDLE } from "../config/iGetToCourse";

/**
 * BUNDLE LANDING — /i-get-to-bundle
 * "Start + Deepen Bundle — Both I GET TO Self-Guided Courses" ($11.11)
 *
 * The 11:11 bundle. Master alignment pricing. Save $6.65 on the pair.
 */

const BRAND = { teal: "#068fa2", gold: "#d4af6a", mint: "#5EEAD4" };

export default function IGetToBundlePage() {
  return (
    <CourseLandingPage
      product={BUNDLE}
      headline={
        <>
          Begin and{" "}
          <span style={{ color: BRAND.mint, fontStyle: "italic" }}>deepen.</span>
          <br />
          <span style={{ color: BRAND.gold }}>The 11:11 Bundle.</span>
        </>
      }
      whoFor={{
        eyebrow: "Why a bundle",
        headlineNode: (
          <>
            One ladder.{" "}
            <span className="italic" style={{ color: BRAND.teal }}>
              Two doable courses. Forever yours.
            </span>
          </>
        ),
        paragraphs: [
          "Course 1 — Start Living I GET TO — is the on-ramp. 20 pages. 5 phases. The tools that turn 'I have to' into 'I GET TO,' and a daily practice as simple as brushing your teeth.",
          "Course 2 — The Deeper Return — is what comes after the wake-up. 18 pages. 6 movements. The integration work that lets the shift STAY — in the body, in the relationships, in the long game.",
          "Together they're $17.76. Bundled, they're $11.11 — the number of master alignment. Save $6.65 and grab both, because the spiral doesn't stop at the first turn.",
        ],
      }}
      includes={[
        "Course 1 — Start Living I GET TO (20 pages · 5 phases) — instant PDF.",
        "Course 2 — The Deeper Return (18 pages · 6 movements) — instant PDF.",
        "38 pages of self-guided work in total. Yours forever.",
        '"Right now" prompts and "Write it down to anchor it" journaling in every lesson — no fluff, no padding.',
        "From beginner I GET TO reframe → somatic literacy, legacy work, and the Long Game.",
        "No video, no audio, no overwhelm. Read it. Do it. Anchor it. Then deepen it.",
        "Master-alignment pricing — $11.11 because the women drawn to this work notice the 11:11.",
        "Both PDFs land in your hands the moment checkout closes.",
      ]}
      honestNote={
        <>
          Honest note: bundling these two isn't a marketing trick. It's the natural order. Course 1
          wakes you up; Course 2 keeps you awake. Bundling them together is how the work was
          designed to flow — and at $11.11, it's the easiest "yes" I could give you.
          <br />
          <br />
          The paperback ($19.99, mid-June) is still the keepsake — the artifact for your nightstand.
          These two courses are the tools you USE while the paperback prints.
          <br />
          <br />
          <span style={{ color: BRAND.teal, fontStyle: "normal", fontWeight: 500 }}>
            Begin. Deepen. Embody. In that order.
          </span>
        </>
      }
      closer={{
        headlineNode: (
          <>
            $11.11 for both.
            <br />
            <span style={{ color: BRAND.mint, fontStyle: "italic" }}>
              Master alignment is on sale tonight.
            </span>
          </>
        ),
        paragraph:
          "Download both. Open Course 1 first. Sit with it for a week. Then move into The Deeper Return. The whole ladder, in one click.",
      }}
      metaDesc="The 11:11 Bundle — both I GET TO self-guided courses by Temple Franklin. 38 pages. Start Living I GET TO + The Deeper Return. Save $6.65 with master-alignment pricing. $11.11. Instant download."
      ldSku="MBSH-IGT-BUNDLE"
    />
  );
}
